import { cssVar } from '@chakra-ui/react';

const $width = cssVar('switch-track-width');
const $height = cssVar('switch-track-height');

const baseStyleTrack = () => {
  return {
    borderRadius: 'full',
    p: '2px',
    width: [$width.reference],
    height: [$height.reference],
    transitionProperty: 'common',
    transitionDuration: 'fast',
    // Dark mode keeps the light switch (design): the off track takes the
    // light secondary-300 instead of the inverted dark grey.
    bg: 'var(--kula-dark-switch-track, var(--kula-colors-secondary-300))',
    _focus: {
      boxShadow: 'none',
    },
    _disabled: {
      opacity: 0.4,
      cursor: 'not-allowed',
    },
    _checked: {
      bg: '#00875A',
    },
  };
};

const baseStyle = (props) => ({
  track: baseStyleTrack(props),
  // Chakra's default thumb is `white`, which dark mode turns into the dark
  // surface; the thumb stays white in both themes.
  thumb: { bg: 'static-white' },
});

const sizes = {
  md: {
    container: {
      [$width.variable]: '30px',
      [$height.variable]: '14px',
    },
  },
};

const defaultProps = {
  size: 'md',
};

export const Switch = {
  baseStyle,
  sizes,
  defaultProps,
};
